// extracted by mini-css-extract-plugin
module.exports = {"cards":"Profile_cards__3g9-_"};